var map = {
	"./float_applemusic.png": "55ec",
	"./float_discord.png": "8832",
	"./float_pandora.png": "d5c2",
	"./float_spotify.png": "0771",
	"./float_tidal.png": "a059",
	"./float_youtube.png": "e661"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f40f";